import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
} from '@angular/router';
import Session from 'supertokens-web-js/recipe/session';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root',
})
export class RoleAuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authService: AuthService
    ) {}

    async canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        const isAuthenticated = await Session.doesSessionExist();

        if (!isAuthenticated) {
            this.router.navigate(['/auth']); // Redirect to login if not authenticated
            return false;
        }

        // Extract required roles from route data
        const requiredRoles: string[] | undefined = route.data['roles'];

        if (requiredRoles && requiredRoles.length > 0) {
            const hasRoles =
                await this.authService.hasRequiredRoles(requiredRoles);

            if (!hasRoles) {
                const hasRolesAfterRefresh =
                    await this.authService.waitForRequiredRoles(
                        requiredRoles,
                        3,
                        800
                    );

                if (!hasRolesAfterRefresh) {
                    this.router.navigate(['/request-permission'], {
                        queryParams: { returnUrl: state.url },
                    });
                    return false;
                }
            }
        }

        return true;
    }
}
